import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { details, FetchStudentWiseEarningDetails as FetchEarningDetails } from "./PaymentSlice";
import BackButton from "../../component/BackButton";
import DatePicker from "react-multi-date-picker";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { areaCodeListingSelector, FetchAreaCodeList } from "../areacode/slice";
import { SchoolListReducer } from "../slice";
import { CSVLink, CSVDownload } from "react-csv";
import Loader from "../../component/Loader";
function TeacherEarningStudentDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state?.payment?.detail);
  const teacher = useSelector((state) => state?.payment?.teacher);
  console.log(data, "earning data");
  const [loading, setLoading] = useState(false);
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [page, setPage] = useState("1");
  const [show, setShow] = useState(false);
  const [schoolId, setSchoolId] = useState("");
  const [areacode, setAreacode] = useState("");
  const Schoollist = useSelector((state) => state.main.schools);
  const arealist = useSelector(areaCodeListingSelector);
  const [limit, setLimit] = useState(10);
  const [submitting, setSubmitting] = useState(false);
  const adminPercent = 10;
  const [hallfee, setHallfee] = useState(0);
  const [franchisefee, setFranchisefee] = useState(0);
  const [earnings, setEarnings] = useState({
    grossEarning: 0,
    netEarning: 0,
    adminEarning: 0,
  });
  const [csvData, setCsvData] = useState("");
  const [showClassDetails, setShowClassDetails] = useState(true);
  const [showEarningBreakdown, setShowEarningBreakdown] = useState(true);
  const [showStudentList, setShowStudentList] = useState(true);
  useEffect(() => {
    dispatch(FetchAreaCodeList({ page: 1, limit: 100000000 }));
  }, [dispatch]);

  useEffect(() => {
    if (areacode) {
      dispatch(
        SchoolListReducer({
          page: 1,
          limit: 100000000,
          search: "",
          areacode,
        })
      );
    }
  }, [dispatch, areacode]);
  useEffect(() => {
    setLoading(true);
    dispatch(
      FetchEarningDetails({
        teacherId: id,
        page: page,
        limit,
        areacode,
        schoolId,
      })
    )
      .then((res) => {
        if (res?.payload?.code === 1) {
          setLoading(false);
          setHallfee(res?.payload?.data?.calculated_hall_fee)
          setFranchisefee(res?.payload?.data?.calculated_franchise_fee)
          let adminCut = res?.payload?.data?.admin_percentage;
          let arr = res?.payload?.data?.earning_details;
          let a = 0;
          let n = 0;
          let g = 0;
          arr?.forEach((item) => {
            let x =
              Number(item?.amount) -
              (Number(item?.amount) * Number(adminCut)) / 100;
            a += (Number(item?.amount) * Number(adminCut)) / 100;
            g += Number(item?.amount);

            n += x;
          });
          setEarnings({
            grossEarning: parseFloat(g).toFixed(2),
            netEarning: parseFloat(n).toFixed(2),
            adminEarning: parseFloat(a).toFixed(2),
          });
          let ob = {
            res: res,
            earning: {
              grossEarning: parseFloat(g).toFixed(2),
              netEarning: parseFloat(n).toFixed(2),
              adminEarning: parseFloat(a).toFixed(2),
            },
          };
          return ob;
        }
      })
      .then((ot) => {
        if (ot?.res?.payload?.code === 1) {
          console.log(ot, "Ot");
          let arr = ot?.res?.payload?.data?.earning_details;
          let adminPercent = ot?.res?.payload?.data?.admin_percentage;
          let datas = arr.map((st) => {
            let student = st?.student_details;
            return {
              "Booking Id": st?.bookingId,
              "Student Id": st?.studentId,
              Date: st?.date,
              "First Name": student?.first_name,
              "Last name": student?.last_name,
              "Medical note": student?.medical_note,
              Address: student?.address,
              Discipline: student?.discipline_details?.name,
              Image: student?.image,
              "Emergency contactNo": student?.emergency_contactNo,
              "Emergency countryCode": student?.emergency_countryCode,
              Dob: student?.dob
                ? moment(student?.dob).format("DD MMM YYYY")
                : "",
              "Student type": student?.student_type,
              "Areacode details": student?.areacode_details?.areacode,
              "School details": student?.school_details?.name,
              "Gross amount": st?.amount,
              "Admin earning": st?.amount * adminPercent,
              "Net amount":
                Number(st?.amount) - Number((st?.amount * adminPercent) / 100),
              "Payment date": st?.createdAt
                ? moment(st?.createdAt).format("DD MMM YYYY")
                : "",
            };
          });
          setCsvData(datas);
        }
      });
  }, [dispatch, id, areacode, schoolId, limit, page]);

  useEffect(() => {
    return () => {
      dispatch(details(null));
    };
  }, [dispatch]);

  const handleSubmit = () => {
    if (id && start_date && end_date) {
      setSubmitting(true);
      setLoading(true);
      dispatch(
        FetchEarningDetails({
          page: 1,
          limit: 10000,
          teacher_id: id,
          start_date: moment(start_date).format("YYYY-MM-DD"),
          end_date: moment(end_date).format("YYYY-MM-DD"),
        })
      ).then((res) => {
        setSubmitting(false);
        setLoading(false);
        if (res?.payload?.code === 1) {
          let adminCut = res?.payload?.data?.admin_percentage;
          let arr = res?.payload?.data?.earning_details;
          let a = 0;
          let n = 0;
          let g = 0;
          arr?.forEach((item) => {
            let x =
              Number(item?.amount) -
              (Number(item?.amount) * Number(adminCut)) / 100;
            a += (Number(item?.amount) * Number(adminCut)) / 100;
            g += Number(item?.amount);

            n += x;
          });
          setEarnings({
            grossEarning: parseFloat(g).toFixed(2),
            netEarning: parseFloat(n).toFixed(2),
            adminEarning: parseFloat(a).toFixed(2),
          });
        }
      });
    }
  };

  // const getCsvData = useCallback(() => {
  //   console.log(data, "Earning detail data");
  //   if (data) {
  //     let arr = [...data];
  //     let datas = arr.map((st) => {
  //       let student = st?.student_details;
  //       return {
  //         id: student?.studentId,
  //         bookingId: it?.bookingId,
  //         date: it?.date,
  //         first_name: student?.first_name,
  //         last_name: student?.last_name,
  //         medical_note: student?.medical_note,
  //         address: student?.address,
  //         discipline: student?.discipline_details?.name,
  //         image: student?.image,
  //         emergency_contactNo: student?.emergency_contactNo,
  //         emergency_countryCode: student?.emergency_countryCode,
  //         dob: student?.dob ? moment(student?.dob).format("DD MMM YYYY") : "",
  //         student_type: student?.student_type,
  //         areacode_details: student?.areacode_details?.name,
  //         school_details: student?.school_details?.name,
  //         gross_amount: student?.gross_amount,
  //         admin_earning: student?.admin_earning,
  //         net_amount: student?.net_amount,
  //         "payment date": student?.createdAt
  //           ? moment(student?.createdAt).format("DD MMM YYYY")
  //           : "",
  //       };
  //     });
  //     setCsvData(datas);
  //   }
  //   // return datas;
  // }, [data?.student_list]);

  // useEffect(() => {
  //   if (data) {
  //     getCsvData();
  //   }
  // }, [getCsvData, data]);

  return (
    <article className="col-lg-9">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center mb-3">
          <div className="col-auto">
            <BackButton />
          </div>
          <div className="col">
            <h3 className="mb-0">Earning Breakdown</h3>
          </div>
          <div className="col-auto ms-auto">
            <div className="d-flex align-items-center gap-2">
                <img 
                  src={teacher?.image || "assets/images/upload-img.png"} 
                  alt={teacher?.full_name} 
                  style={{
                    width: '40px', 
                    height: '40px', 
                    borderRadius: '50%', 
                    objectFit: 'cover'
                  }} 
                />
              <span style={{fontSize: '0.9rem', fontWeight: '500'}}>{teacher?.full_name}</span>
            </div>
            </div>
          <div className="col-auto ms-auto">
            {csvData && (
              <CSVLink filename={"earnings.csv"} data={csvData || []}>
                <button type="button" className="btn btn-save p-2 fs-6">
                  <i className="fa fa-download me-1"></i> Download CSV
                </button>
              </CSVLink>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-5 col-xl-5 mb-3 d-none">
            <div className="d-flex align-items-center lg-justify-content-end">
              <form className="has-search">
                <span className="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control shadow"
                  placeholder="Search earning by teacher name"
                />
              </form>
              <div
                className=""
                onClick={() => {
                  setShow(!show);
                }}
              >
                <img
                  src="assets/images/filter.png"
                  alt=""
                  className="p-0 m-0"
                  height={"70px"}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3 align-items-end">
          <div className="col-sm-12 mb-3">
            {loading ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                  <div className="spinner"></div>
                  <p style={{ fontSize: "14px", color: "#555", margin: 0 }}>
                    Please wait... Loading earning details.
                  </p>
                </div>
              </div>
            ) : data?.length > 0 && (
              <div className="card mb-3 shadow-sm" style={{border: '1px solid #d1d5db', borderRadius: '8px'}}>
                <div 
                  className="card-header" 
                  style={{background: '#f9fafb', borderBottom: '1px solid #e5e7eb', cursor: 'pointer', padding: '15px 20px'}}
                  onClick={() => setShowClassDetails(!showClassDetails)}
                >
                  <h5 className="mb-0 d-flex justify-content-between align-items-center" style={{fontSize: '1.1rem', fontWeight: '600', color: '#374151'}}>
                    <span>
                      {data[0]?.class_details ? 'Class Details' : data[0]?.event_details ? 'Event Details' : 'Booking Details'}
                    </span>
                    <i className={`fa fa-chevron-${showClassDetails ? 'up' : 'down'}`} style={{fontSize: '0.9rem', color: '#6b7280'}}></i>
                  </h5>
                </div>
                {showClassDetails && (
                  <div className="card-body" style={{padding: '20px'}}>
                    {data[0]?.class_details ? (
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Class Name:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.class_details?.name || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Date:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.date ? moment(data[0]?.date).format("DD MMM YYYY") : 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Time:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.time_slot_details?.start_time || 'N/A'} - {data[0]?.time_slot_details?.end_time || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Venue:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.class_details?.school_details?.name || 'N/A'}, {data[0]?.class_details?.school_details?.address || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Child Price:</strong>
                            <span style={{color: '#374151'}}>
                              {data[0]?.class_details?.child_price ? `£${data[0]?.class_details?.child_price}` : 'N/A'}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Total Seats:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.class_details?.total_seats || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Adult Price:</strong>
                            <span style={{color: '#374151'}}>
                              {data[0]?.class_details?.adult_price ? `£${data[0]?.class_details?.adult_price}` : 'N/A'}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Discipline:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.class_details?.discipline_details?.name || 'N/A'}</span>
                          </div>
                        </div>

                      </div>
                    ) : data[0]?.event_details ? (
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Event Name:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.event_details?.name || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Date:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.date ? moment(data[0]?.date).format("DD MMM YYYY") : 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Time:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.event_details?.start_time || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Venue:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.event_details?.school_details?.name || 'N/A'}, {data[0]?.event_details?.school_details?.address || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Child Price:</strong>
                            <span style={{color: '#374151'}}>
                              {data[0]?.event_details?.child_price ? `£${data[0]?.event_details?.child_price}` : 'N/A'}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Discipline:</strong>
                            <span style={{color: '#374151'}}>{data[0]?.event_details?.discipline_details?.name || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-start">
                            <strong style={{minWidth: '120px', color: '#6b7280'}}>Adult Price:</strong>
                            <span style={{color: '#374151'}}>
                              {data[0]?.event_details?.adult_price ? `£${data[0]?.event_details?.adult_price}` : 'N/A'}
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="col-sm-12 mb-3">
            {data?.length > 0 && (
              <div className="card mb-3 shadow-sm" style={{border: '1px solid #d1d5db', borderRadius: '8px'}}>
                <div 
                  className="card-header" 
                  style={{background: '#f0fdf4', borderBottom: '1px solid #bbf7d0', cursor: 'pointer', padding: '15px 20px'}}
                  onClick={() => setShowEarningBreakdown(!showEarningBreakdown)}
                >
                  <h5 className="mb-0 d-flex justify-content-between align-items-center" style={{fontSize: '1.1rem', fontWeight: '600', color: '#166534'}}>
                    <span>
                      Earning Breakdown
                    </span>
                    <i className={`fa fa-chevron-${showEarningBreakdown ? 'up' : 'down'}`} style={{fontSize: '0.9rem', color: '#16a34a'}}></i>
                  </h5>
                </div>
                {showEarningBreakdown && (
                  <div className="card-body" style={{padding: '20px'}}>
                    <div className="row g-2">
                      <div className="col-md-12">
                                  <div className="p-3" style={{background: '#f8f9fa', borderRadius: '6px', borderLeft: '3px solid #6c757d'}}>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span style={{fontSize: '0.95rem', color: '#555'}}>Total Students</span>
                                      <strong style={{fontSize: '1.1rem', color: '#333'}}>{data?.length || 0}</strong>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="p-3" style={{background: '#f8f9fa', borderRadius: '6px', borderLeft: '3px solid #6c757d'}}>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span style={{fontSize: '0.95rem', color: '#555'}}>Gross Amount</span>
                                      <strong style={{fontSize: '1.1rem', color: '#333'}}>
                                        <i className="fa fa-gbp"></i> {data?.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0).toFixed(2)}
                                      </strong>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="p-3" style={{background: '#f8f9fa', borderRadius: '6px', borderLeft: '3px solid #6c757d'}}>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span style={{fontSize: '0.95rem', color: '#555'}}>Franchise Fee</span>
                                      <strong style={{fontSize: '1.1rem', color: '#333'}}>
                                        <i className="fa fa-gbp"></i>{parseFloat(franchisefee).toFixed(2)}
                                      </strong>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="p-3" style={{background: '#f8f9fa', borderRadius: '6px', borderLeft: '3px solid #6c757d'}}>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span style={{fontSize: '0.95rem', color: '#555'}}>Hall Fee</span>
                                      <strong style={{fontSize: '1.1rem', color: '#333'}}>
                                        <i className="fa fa-gbp"></i> {parseFloat(hallfee).toFixed(2)}
                                      </strong>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="p-3" style={{background: '#f8f9fa', borderRadius: '6px', borderLeft: '3px solid #007bff'}}>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span style={{fontSize: '0.95rem', color: '#555'}}>Admin Commission ({adminPercent}%)</span>
                                      <strong style={{fontSize: '1.1rem', color: '#007bff'}}>
                                        <i className="fa fa-gbp"></i> {(() => {
                                          const grossAmount = data?.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0);
                                          const totalFees = parseFloat(hallfee) + parseFloat(franchisefee);
                                          const admin_commission = ((grossAmount - totalFees) * adminPercent / 100);
                                          return admin_commission.toFixed(2);
                                        })()}
                                      </strong>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="p-3" style={{background: '#e8f5e9', borderRadius: '6px', borderLeft: '3px solid #28a745'}}>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span style={{fontSize: '0.95rem', color: '#555', fontWeight: '600'}}>Teacher Net Income</span>
                                      <strong style={{fontSize: '1.2rem', color: '#28a745'}}>
                                        <i className="fa fa-gbp"></i> {(() => {
                                          const grossAmount = data?.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0);
                                          const totalFees = parseFloat(hallfee) + parseFloat(franchisefee);
                                          const admin_commission = ((grossAmount - totalFees) * adminPercent / 100);
                                          const teacher_net_income = grossAmount - (totalFees + admin_commission);
                                          return teacher_net_income.toFixed(2);
                                        })()}
                                      </strong>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="p-3" style={{background: '#fff3cd', borderRadius: '6px', borderLeft: '3px solid #ffc107'}}>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span style={{fontSize: '0.95rem', color: '#555', fontWeight: '600'}}>Admin Net Income</span>
                                      <strong style={{fontSize: '1.2rem', color: '#f57c00'}}>
                                        <i className="fa fa-gbp"></i> {(() => {
                                          const grossAmount = data?.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0);
                                          const totalFees = parseFloat(hallfee) + parseFloat(franchisefee);
                                          const admin_commission = ((grossAmount - totalFees) * adminPercent / 100);
                                          const admin_net_income = totalFees + admin_commission;
                                          return admin_net_income.toFixed(2);
                                        })()}
                                      </strong>
                                    </div>
                                  </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="col-sm-12 mb-3">
            {data?.length > 0 && (
              <div className="card mb-3 shadow-sm" style={{border: '1px solid #d1d5db', borderRadius: '8px'}}>
                <div 
                  className="card-header" 
                  style={{background: '#eff6ff', borderBottom: '1px solid #bfdbfe', cursor: 'pointer', padding: '15px 20px'}}
                  onClick={() => setShowStudentList(!showStudentList)}
                >
                  <h5 className="mb-0 d-flex justify-content-between align-items-center" style={{fontSize: '1.1rem', fontWeight: '600', color: '#1e40af'}}>
                    <span>
                      Student List
                    </span>
                    <i className={`fa fa-chevron-${showStudentList ? 'up' : 'down'}`} style={{fontSize: '0.9rem', color: '#2563eb'}}></i>
                  </h5>
                </div>
                {showStudentList && (
                  <div className="card-body" style={{padding: '0'}}>
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    {/* <th scope="col">Student name</th> */}
                    <th scope="col">Student Name</th>
                    <th scope="col">Order Id</th>
                    <th scope="col">Amount Paid</th>
                    <th scope="col">Created Date</th>
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={8}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {data?.length > 0 ? (
                        <>
                        {data?.map((item, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                {item?.student_details?.first_name?.charAt(0).toUpperCase() + item?.student_details?.first_name?.slice(1).toLowerCase()}{" "}
                                {item?.student_details?.last_name?.charAt(0).toUpperCase() + item?.student_details?.last_name?.slice(1).toLowerCase()}
                                {" "}<small>({item?.student_details?.student_type})</small>
                              </td>
                              <td>{item?.id}</td>
                              <td>
                                <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                                {parseFloat(Number(item?.amount)) || 0}
                              </td>
                              <td>
                                {item?.date
                                  ? moment(item?.date).format("DD MMM YYYY")
                                  : "NA"}
                              </td>
                            </tr>
                          );
                        })}
                        <tr style={{backgroundColor: '#f8f9fa', fontWeight: 'bold', borderTop: '2px solid #dee2e6'}}>
                          <td colSpan={2} style={{textAlign: 'right', padding: '0px'}}>Total:</td>
                          <td style={{padding: '12px'}}>
                            <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {data?.reduce((sum, item) => sum + (parseFloat(Number(item?.amount)) || 0), 0).toFixed(2)}
                          </td>
                          <td></td>
                        </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan={4}>No data found.</td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
                  </div>
                )}
              </div>
            )}
            {!loading && (!data || data?.length === 0) && (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <p style={{ fontSize: "16px", color: "#999", margin: 0 }}>
                  No earning details found.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}

export default TeacherEarningStudentDetails;
